import {
	CerrarSesion,
	Nav,
	NavGroup,
	NavItem,
	NavTitle,
	Spacer,
} from "../LeftMenu";
import {
	AssignmentAdd,
	ResetSettings,
	Speed,
	AssignmentList,
	DashboardCustomize,
	Calendar,
	Box,
	Factory,
} from "@/assets/icons/Icons";

export function MainUserMenu() {
	return (
		<Nav>
			<NavTitle>Gestor Huella de Carbono</NavTitle>
			<NavGroup>
				<NavItem
					title="Dashboard"
					description="Visualiza los KPIs de CO2 y compara con otras empresas del cluster."
					url="/user/dashboard"
					icon={Speed}
				/>
				<NavItem
					title="Imputaciones"
					description="Listado y edición de las imputaciones realizadas."
					url="/user"
					icon={AssignmentList}
				/>
				<NavItem
					title="Nueva Imputación"
					description="Crea una nueva imputación basada en la configuración de tu empresa."
					url="/user/input/new"
					icon={AssignmentAdd}
				/>
			</NavGroup>
			<NavItem
				title="Datos Anuales"
				description="Listado y edición de datos de la empresa."
				url="/user/empresa"
				icon={Calendar}
			/>

			<NavItem
				title="Organizacion"
				description="Gestiona y visualiza la huella de carbono de tus referencias."
				url="/user/organizacion"
				icon={Factory}
			/>
			<NavItem
				title="Proyectos"
				description="Gestiona y visualiza la huella de carbono de tus referencias."
				url="/user/proyectos"
				icon={Box}
			/>

			<Spacer />

			<NavGroup>
				<NavItem
					title="Emisores de Co2"
					description="Modifica la configuración de emisiones de tu empresa."
					url="/user/config"
					icon={ResetSettings}
				/>
				<NavItem
					title="Factores Personalizados"
					description="Gestiona tus factores de emisión personalizados."
					url="/user/configFactores"
					icon={DashboardCustomize}
				/>
			</NavGroup>

			<CerrarSesion />
		</Nav>
	);
}
